// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getTags: '/catalog/tag',
  opTag: '/catalog/tag',
}

// get Tags
export async function getTags(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getTags
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }

  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`

        // el dispositivo lo hago objeto
        o.device = JSON.parse(o.device)

        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo variables',
        description: error.message,
      })
    })
}

// add new tag
export async function postTag(token, tag) {
  const url = fsConfig.root + fsConfig.opTag
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }

  // borra los campos auxiliares que no se graban
  delete tag.deviceMaster

  return axios
    .post(url, tag, newConfig)
    .then(response => {
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando variable',
        description: error.message,
      })
    })
}

export async function putTag(token, tag) {
  const url = fsConfig.root + fsConfig.opTag
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  const { key } = tag
  delete tag.key
  delete tag.deviceMaster
  delete tag.device

  return axios
    .put(url, tag, newConfig)
    .then(response => {
      response.key = key
      return response
    })
    .catch(error => {
      console.log('Error:', error)
      notification.warning({
        message: 'Error grabando variable',
        description: error.message,
      })
    })
}

export async function deleteTag(token, tagUid) {
  const url = `${fsConfig.root}${fsConfig.opTag}/${tagUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando variable',
        description: error.message,
      })
    })
}
